import React from "react";
import { CommandPalette } from "./command/CommandPalette";

export const WorkspaceSearch: React.FC = () => {
  return <CommandPalette />;
};
